import axios from "axios";

export function fetchOverrideWarningList(payload) {
  return new Promise((resolve, reject) => {
    axios.get(`/serialnumber/api/v1/product-ui-template/override-warning-list/${payload.id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}
